import { gql } from '@apollo/client'

export default gql`
  fragment widgetByStatusResultMeta on WidgetByStatusResult {
    total
    delayed
    delayedPercentage
  }
`
